import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { addIcons } from 'ionicons';
import { chevronDown } from 'ionicons/icons';

addIcons({ chevronDown });

defineCustomElements(window);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));